import Main from '@/views/main.vue';
import {
  initAuthRouters
} from "../libs/combineAuthRouters";


export const ROUTER_NAME_HOME = "home";
export const ROUTER_NAME_LOGIN = "login";
export const ROUTER_INDEX = ROUTER_NAME_LOGIN;
export const ROUTER_LOGIN_SSO = "login-sso";
export const ROUTER_NAME_404 = 'error-404';
export const ROUTER_NAME_403 = 'error-403';
export const ROUTER_ADMIN = 'account-info';
export const ROUTER_DEFAULT = ROUTER_ADMIN;


// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
  path: '/login',
  name: ROUTER_NAME_LOGIN,
  meta: {
    title: 'Login - 登录'
  },
  component: resolve => {
    require(['@/views/login.vue'], resolve);
  }
};
export const loginSSORouter = {
  path: '/login-sso',
  name: ROUTER_LOGIN_SSO,
  meta: {
    title: '进入财务共享中心'
  },
  component: resolve => {
    require(['@/views/login-sso.vue'], resolve);
  }
};
// 账套设置等
export const accountRouter = {
  path: '/account-info',
  name: ROUTER_ADMIN,
  meta: {
    title: '账套管理'
  },
  component: resolve => {
    require(['@/views/account-info/index.vue'], resolve);
  }
};

export const page404 = {
  path: '/*',
  name: ROUTER_NAME_404,
  meta: {
    title: '404-页面不存在'
  },
  component: resolve => {
    require(['@/views/error-page/404.vue'], resolve);
  }
};

export const page403 = {
  path: '/403',
  meta: {
    title: '403-权限不足'
  },
  name: ROUTER_NAME_403,
  component: resolve => {
    require(['@//views/error-page/403.vue'], resolve);
  }
};

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
  path: '/',
  name: 'otherRouter',
  redirect: '/login',
  component: Main,
  children: [{
    path: '/home',
    title: "首页",
    name: ROUTER_NAME_HOME,
    component: resolve => {
      require(['@/views/home/index.vue'], resolve);
    }
  }]
};

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const menuRouters = [
  { //账套管理
    path: '/account-management',
    icon: 'account-management',
    title: '账套管理',
    name: 'account-management',
    component: Main,
    children: [
      {
        path: "template-set",
        title: "模板账套",
        icon: "icon-a-huijikemubumen",
        meta: {
          title: '运营中心-模板账套'
        },
        name: "template-set",
        component: resolve => {
          require(["../views/account-management/template-set/index.vue"], resolve);
        }
      },
      {
        path: "deprtment-manage",
        title: "部门管理",
        icon: "icon-a-huijikemubumen",
        meta: {
          title: '运营中心-部门管理'
        },
        name: "deprtment-manage",
        component: resolve => {
          require(["../views/account-management/department/index.vue"], resolve);
        }
      },
      {
        path: "rank-category",
        title: "职级类别",
        icon: "icon-yuangong",
        meta: {
          title: '运营中心-职级类别'
        },
        name: "rank-category",
        component: resolve => {
          require(["../views/account-management/rank-category/index.vue"], resolve);
        }
      },
      {
        path: "employee-management",
        title: "员工管理",
        icon: "icon-yuangong",
        meta: {
          title: '运营中心-员工管理'
        },
        name: "employee-management",
        component: resolve => {
          require(["../views/account-management/employee-management/index.vue"], resolve);
        }
      },
      {
        path: "function-module",
        title: "功能模块",
        icon: "icon-gongneng",
        meta: {
          title: '运营中心-功能模块'
        },
        name: "function-module",
        component: resolve => {
          require(["../views/account-management/function-module/index.vue"], resolve);
        }
      },
      {
        path: "supplier-manage",
        title: "供应商管理",
        icon: "icon-gongyingshang",
        meta: {
          title: '运营中心-供应商管理'
        },
        name: "supplier-manage",
        component: resolve => {
          require(["../views/account-management/supplier/index.vue"], resolve);
        }
      },
      {
        path: "measure-unit",
        title: "计量单位",
        icon: "icon-jiliangdanwei1",
        meta: {
          title: '运营中心-计量单位'
        },
        name: "measure-unit",
        component: resolve => {
          require(["../views/account-management/measure-unit/"], resolve);
        }
      },
      {
        path: "bank-management",
        title: "账户管理",
        icon: "icon-yinhangzhanghuguanli",
        meta: {
          title: '运营中心-账户管理'
        },
        name: "bank-management",
        component: resolve => {
          require(["../views/account-management/bank-management/index.vue"], resolve);
        }
      },
      {
        path: "acc-management",
        title: "科目管理",
        icon: "icon-a-huijikemubumen",
        meta: {
          title: '运营中心-科目管理'
        },
        name: "acc-management",
        component: resolve => {
          require(["../views/account-management/acc-management/index.vue"], resolve);
        }
      },

      {
        path: "client-manage",
        title: "客户管理",
        icon: "icon-kehu",
        meta: {
          title: '运营中心-客户管理'
        },
        name: "client-manage",
        component: resolve => {
          require(["../views/account-management/supplier/index.vue"], resolve);
        }
      },
      {
        path: "warehouse-manage",
        title: "仓库管理",
        icon: "icon-cangku",
        meta: {
          title: '运营中心-仓库管理'
        },
        name: "warehouse-manage",
        component: resolve => {
          require(["../views/account-management/warehouse/index.vue"], resolve);
        }
      },
      {
        path: "project-management",
        title: "项目管理",
        icon: "icon-a-kemuxinxixiangmu-01",
        meta: {
          title: '运营中心--项目管理'
        },
        name: "project-management",
        component: resolve => {
          require(["../views/account-management/project-management/index.vue"], resolve);
        }
      },
      {
        path: "inventory-management",
        title: "商品/存货管理",
        icon: "icon-cunhuo",
        meta: {
          title: '运营中心-商品/存货管理'
        },
        name: "inventory-management",
        component: resolve => {
          require(["../views/account-management/inventory-management/index.vue"], resolve);
        }
      },
      {
        path: "batch-management",
        title: "批次管理",
        icon: 'icon-bianmaguize',
        meta: {
          title: '运营中心-批次管理'
        },
        name: "batch-management",
        component: resolve => {
          require(["../views/account-management/batch-management/index.vue"], resolve);
        }
      },
      {
        path: 'invoices-coding',
        title: '单据编码',
        icon: "icon-bianmaguize",
        meta: {
          title: '运营中心-单据编码'
        },
        name: 'invoices-coding',
        component: resolve => {
          require(["../views/finance-account/invoices-coding/index.vue"], resolve)
        }
      },



    ]
  },
  //全局数据维护
  {
    path: '/global-data-maintain',

    title: '全局数据维护',
    name: 'global-data-maintain',
    component: Main,
    children: [{
      path: "subject-message",
      title: "科目信息",
      icon: 'icon-a-huijikemubumen',
      meta: {
        title: '运营中心-科目信息'
      },
      name: "subject-message",
      component: resolve => {
        require(["@/views/global-data-maintain/subject-message/index.vue"], resolve);
      }
    },
    {
      path: "administrative-region",
      title: "行政区域",
      icon: 'icon-hangzhengquyu',
      meta: {
        title: '运营中心-行政区域'
      },
      name: "administrative-region",
      component: resolve => {
        require(["@/views/global-data-maintain/administrative-region/index.vue"], resolve);
      }
    },
    {
      path: "assets-class",
      title: "资产类别",
      icon: 'icon-zichanleibie',
      meta: {
        title: '运营中心-资产类别'
      },
      name: "assets-class",
      component: resolve => {
        require(["@/views/global-data-maintain/assets-class/index.vue"], resolve);
      }
    },
    {
      path: "tax-classification",
      title: "税收分类",
      icon: 'icon-shuishoufenlei',
      meta: {
        title: '运营中心-税收分类'
      },
      name: "tax-classification",
      component: resolve => {
        require(["@/views/global-data-maintain/tax-classification/index.vue"], resolve);
      }
    },
    {
      path: "business-classification",
      title: "行业分类",
      icon: 'icon-hangyefenlei',
      meta: {
        title: '运营中心-行业分类'
      },
      name: "business-classification",
      component: resolve => {
        require(["@/views/global-data-maintain/business-classification/index.vue"], resolve);
      }
    },
    {
      path: "invoices-coderule",
      title: "单据编码规则",
      icon: 'icon-bianmaguize',
      meta: {
        title: '运营中心-单据编码规则'
      },
      name: "invoices-coderule",
      component: resolve => {
        require(["@/views/global-data-maintain/invoices-coderule/index.vue"], resolve);
      }
    },


    ]

  },
  // 全局会计引擎

  {
    path: "/global-engine",
    icon: "global-engine",
    title: '全局会计引擎',
    name: 'global-engine',
    component: Main,
    children: [{
      path: "cost-type",
      title: "全局费用类型",
      icon: "icon-a-feiyongbaozhangfeiyongpiaoju",
      meta: {
        title: '运营中心-全局费用类型'
      },
      name: "cost-type",
      component: resolve => {
        require(["../views/global-data-maintain/global-engine/cost-type/index"], resolve);
      }
    },

    {
      path: "settle-type",
      title: "全局结算类型",
      icon: "icon-jiesuanzhongxin",
      meta: {
        title: '运营中心-全局结算类型'
      },
      name: "settle-type",
      component: resolve => {
        require(["../views/global-data-maintain/global-engine/settle-type/index"], resolve);
      }
    },
    {
      path: "purchase-type",
      title: "全局采购类型",
      icon: "icon-caigoupiaoju",
      meta: {
        title: '运营中心-全局采购类型'
      },
      name: "purchase-type",
      component: resolve => {
        require(["../views/global-data-maintain/global-engine/purchase-type/index"], resolve);
      }
    },
    {
      path: "sale-type",
      title: "全局销售类型",
      icon: "icon-xiaoshoupiaoju",
      meta: {
        title: '运营中心-全局销售类型'
      },
      name: "sale-type",
      component: resolve => {
        require(["../views/global-data-maintain/global-engine/sale-type/index"], resolve);
      }
    },
    {
      path: "passageway-type",
      title: "全局出入库类型",
      icon: "icon-ruku",
      meta: {
        title: '运营中心-全局出入库类型'
      },
      name: "passageway-type",
      component: resolve => {
        require(["../views/global-data-maintain/global-engine/passageway-type/index"], resolve);
      }
    },
    {
      path: "asset-type",
      title: "全局资产类型",
      icon: "icon-zichan",
      meta: {
        title: '运营中心-全局资产类型'
      },
      name: "asset-type",
      component: resolve => {
        require(["../views/global-data-maintain/global-engine/asset-type/index"], resolve);
      }
    },
    {
      path: "salary-type",
      title: "全局工资类型",
      icon: "icon-yinhangzhanghuguanli",
      meta: {
        title: '运营中心-全局工资类型'
      },
      name: "salary-type",
      component: resolve => {
        require(["../views/global-data-maintain/global-engine/salary-type/index"], resolve);
      }
    },
    {
      path: "zt-configuration",
      title: "全局科目配置",
      icon: "icon-zhangtaopeizhi",
      meta: {
        title: '全局科目配置'
      },
      name: "zt-configuration",
      component: resolve => {
        require(["../views/account-management/zt-configuration/index.vue"], resolve);
      }
    },
    ]
  },
  // 全局系统管理
  {
    path: "/global-system-management",
    icon: "global-system-management",
    title: '全局系统管理',
    name: 'global-system-management',
    component: Main,
    children: [{
      path: "accountant-record-type",
      title: "全局会计档案类型",
      meta: {
        title: '全局系统管理-全局会计档案类型'
      },
      name: "accountant-record-type",
      icon: "icon-qita",
      component: resolve => {
        require(["../views/global-data-maintain/accountant-record-type/index"], resolve);
      }
    },
    {
      path: "catalog-rules",
      title: "全局编目规则",
      icon: "icon-a-kemuxinxixiangmu-01",
      meta: {
        title: '全局报表设置-报表项目'
      },
      name: "catalog-rules",

      component: resolve => {
        require(["../views/global-data-maintain/catalog-rules/index"], resolve);
      }
    },

    ]
  },
  {
    path: "/global-report-set",
    icon: "global-report-set",
    title: '全局报表设置',
    name: 'global-report-set',
    component: Main,
    children: [{
      path: "report-version",
      title: "报表版本",
      meta: {
        title: '全局报表设置-报表版本'
      },
      name: "report-version",
      icon: "icon-qita",
      component: resolve => {
        require(["../views/global-data-maintain/global-engine/cost-type/index"], resolve);
      }
    },
    {
      path: "report-project",
      title: "报表项目",
      icon: "icon-a-kemuxinxixiangmu-01",
      meta: {
        title: '全局报表设置-报表项目'
      },
      name: "report-project",

      component: resolve => {
        require(["../views/global-data-maintain/global-report-set/report-project/index"], resolve);
      }
    },
    {
      path: "report-set",
      title: "报表设置",
      meta: {
        title: '报表设置'
      },
      icon: "icon-baobiaoshezhi",
      name: "report-set",
      component: resolve => {
        require(["../views/global-data-maintain/global-report-set/report-set/index"], resolve);
      }
    },
    ]
  },
  // 账套会计引擎
  {
    path: "/account-engine",
    icon: "account-engine",
    title: '会计引擎',
    name: 'account-engine',
    component: Main,
    children: [
      {
        path: "acc-cost-type",
        title: "费用类型",
        icon: "icon-a-feiyongbaozhangfeiyongpiaoju",

        meta: {
          title: '运营中心-费用类型'
        },
        name: "acc-cost-type",
        component: resolve => {
          require(["../views/global-data-maintain/global-engine/cost-type/index"], resolve);
        }
      },
      {
        path: "acc-settle-type",
        title: "结算类型",
        icon: "icon-jiesuanzhongxin",
        meta: {
          title: '运营中心-结算类型'
        },
        name: "acc-settle-type",
        component: resolve => {
          require(["../views/global-data-maintain/global-engine/settle-type/index"], resolve);
        }
      },
      {
        path: "acc-purchase-type",
        title: "采购类型",
        icon: "icon-caigoupiaoju",
        meta: {
          title: '运营中心-采购类型'
        },
        name: "acc-purchase-type",
        component: resolve => {
          require(["../views/global-data-maintain/global-engine/purchase-type/index"], resolve);
        }
      },
      {
        path: "acc-sale-type",
        title: "销售类型",
        icon: "icon-xiaoshoupiaoju",
        meta: {
          title: '运营中心-销售类型'
        },
        name: "acc-sale-type",
        component: resolve => {
          require(["../views/global-data-maintain/global-engine/sale-type/index"], resolve);
        }
      },
      {
        path: "acc-passageway-type",
        title: "出入库类型",
        icon: "icon-ruku",
        meta: {
          title: '运营中心-出入库类型'
        },
        name: "acc-passageway-type",
        component: resolve => {
          require(["../views/global-data-maintain/global-engine/passageway-type/index"], resolve);
        }
      },
      {
        path: "acc-asset-type",
        title: "资产类型",
        icon: "icon-zichan",
        meta: {
          title: '运营中心-资产类型'
        },
        name: "acc-asset-type",
        component: resolve => {
          require(["../views/global-data-maintain/global-engine/asset-type/index"], resolve);
        }
      },
      {
        path: "acc-salary-type",
        title: "工资类型",
        icon: "icon-yinhangzhanghuguanli",
        meta: {
          title: '运营中心-工资类型'
        },
        name: "acc-salary-type",
        component: resolve => {
          require(["../views/global-data-maintain/global-engine/salary-type/index"], resolve);
        }
      },
      {
        path: "acc-zt-configuration",
        title: "科目配置",
        icon: "icon-zhangtaopeizhi",
        meta: {
          title: '运营中心-科目配置'
        },
        name: "acc-zt-configuration",
        component: resolve => {
          require(["../views/account-management/zt-configuration/index.vue"], resolve);
        }
      },


    ]
  },

  //影像中心
  {
    path: '/image-center',
    icon: 'image-center',
    title: '影像中心',
    name: 'image-center',
    component: Main,
    children: [{
      path: "fee-ticket",
      title: "费用票据",
      icon: "icon-a-feiyongbaozhangfeiyongpiaoju",
      meta: {
        title: '影像中心-费用票据'
      },
      name: "fee-ticket",
      component: resolve => {
        require(["../views/image-center/bill-management/fee-ticket/index"], resolve);
      }
    },
    {
      path: "purchase-ticket",
      title: "采购票据",
      icon: "icon-caigoupiaoju",
      meta: {
        title: '影像中心-采购票据'
      },
      name: "purchase-ticket",
      component: resolve => {
        require(["../views/image-center/bill-management/fee-ticket/index"], resolve);
      }
    },
    {
      path: "sale-ticket",
      title: "销售票据",
      icon: "icon-xiaoshoupiaoju",
      meta: {
        title: '影像中心-销售票据'
      },
      name: "sale-ticket",
      component: resolve => {
        require(["../views/image-center/bill-management/fee-ticket/index"], resolve);
      }
    },
    {
      path: "receiptAndPayment-bill",
      title: "结算票据",
      icon: "icon-shoufukuanpiaoju",
      meta: {
        title: '影像中心-结算票据'
      },
      name: "receiptAndPayment-bill",
      component: resolve => {
        require(["../views/image-center/bill-management/fee-ticket/index"], resolve);
      }
    },

    ]
  },
  //电子文件
  {
    path: '/electrionic',
    icon: 'electrionic',
    title: '电子文件',
    name: 'electrionic',
    component: Main,
    children: [{
      path: "electronic-document",
      title: "电子文件",
      icon: "icon-a-dianzidangandianziwenjian",
      meta: {
        title: '影像中心-电子文件'
      },
      name: "electronic-document",
      component: resolve => {
        require(["../views/image-center/electronic/electronic-document/index"], resolve);
      }
    },
    {
      path: "storge-space",
      title: "存储空间",
      icon: "icon-cunkukongjian",
      meta: {
        title: '影像中心-存储空间'
      },
      name: "storge-space",
      component: resolve => {
        require(["../views/image-center/electronic/storge-space/indx"], resolve);
      }
    },

    ]
  },
  //报账任务
  {
    path: '/billing-task-page',
    icon: 'billing-task-page',
    title: '报账任务',
    name: 'billing-task-page',
    component: Main,
    children: [{
      path: "/billing-task",
      title: "报账任务",
      icon: "icon-baozhangrenwu",
      meta: { title: '报账中心-报账任务' },
      name: "billing-task",
      component: resolve => {
        require(["@/views/billing-center/billing-task/index.vue"], resolve);
      }
    }]
  },
  //我的报账
  {
    path: '/mine-account',
    icon: 'account-management',
    title: '我的报账',
    name: 'mine-account',
    component: Main,
    children: [
      {
        path: "/reimbursement-task",
        title: "费用报账",
        meta: { title: '报账中心-费用报账' },
        name: "reimbursement-task",
        icon: "icon-a-feiyongbaozhangfeiyongpiaoju",
        component: resolve => {
          require(["@/views/billing-center/mine-account/reimbursement-task/index.vue"], resolve);
        }
      },
      {
        path: "/vendor-billing",
        title: "供应商报账",
        meta: { title: '报账中心-供应商报账' },
        icon: "icon-gongyingshang",
        name: "vendor-billing",
        component: resolve => {
          require(["@/views/billing-center/mine-account/vendor-billing/index.vue"], resolve);
        }
      },
      {
        path: "/loan-billing",
        title: "我的借款",
        icon: "icon-gerenjiekuan",
        meta: { title: '报账中心-我的借款' },
        name: "loan-billing",
        component: resolve => {
          require(["@/views/billing-center/mine-account/loan-billing/index.vue"], resolve);
        }
      },
      {
        path: "/mine-repay-ment",
        title: "我的还款",
        icon: "icon-huankuandan",
        meta: { title: '报账中心-我的还款' },
        name: "mine-repay-ment",
        component: resolve => {
          require(["@/views/billing-center/mine-account/mine-repay-ment/index.vue"], resolve);
        }
      },
    ]
  },
  //报账管理
  {
    path: '/billing-management',
    icon: 'billing-management',
    title: '费用报账',
    name: 'billing-management',
    component: Main,
    children: [{
      path: "/expenses-billing-management",
      title: "费用报账单",
      icon: "icon-a-feiyongbaozhangfeiyongpiaoju",
      meta: { title: '报账中心-费用报账单' },
      name: "expenses-billing-management",
      component: resolve => {
        require(["@/views/billing-center/billing-management/expenses-billing-management/index.vue"], resolve);
      }
    },
    {
      path: "/expenses-account-management",
      title: "费用结算单",
      icon: "icon-jiesuanzhongxin",
      meta: { title: '报账中心-费用结算单' },
      name: "expenses-account-management",
      component: resolve => {
        require(["@/views/billing-center/billing-management/expenses-account-management/index.vue"], resolve);
      }
    },
    {
      path: "/loan-management",
      title: "借款单",
      icon: "icon-jiekuandan",
      meta: { title: '报账中心-借款单' },
      name: "loan-management",
      component: resolve => {
        require(["@/views/billing-center/billing-management/loan-management/index.vue"], resolve);
      }
    },
    {
      path: "/personal-borrowing-management",
      title: "借款管理",
      icon: "icon-gerenjiekuan",
      meta: { title: '报账中心-借款管理' },
      name: "personal-borrowing-management",
      component: resolve => {
        require(["@/views/billing-center/billing-management/personal-borrowing-management/index.vue"], resolve);
      }
    },
    {
      path: "/repay-ment",
      title: "还款单",
      icon: "icon-gerenjiekuan",
      meta: { title: '报账中心-还款单' },
      name: "repay-ment",
      component: resolve => {
        require(["@/views/billing-center/billing-management/repay-ment/index.vue"], resolve);
      }
    },
    ]
  },
  //采购报账
  {
    path: '/purchase-account',
    icon: 'purchase-account',
    title: '采购报账',
    name: 'purchase-account',
    component: Main,
    children: [{
      path: "/purchase-account-manage",
      title: "采购报账单",
      icon: "icon-caigou123",
      meta: { title: '报账中心-采购报账单' },
      name: "purchase-account-manage",
      component: resolve => {
        require(["@/views/billing-center/purchase-account/purchase-account-manage/index.vue"], resolve);
      }
    },
    {
      path: "/red-purchase-account",
      title: "红字采购报账单",
      icon: "icon-hongzidan",
      meta: { title: '报账中心-红字采购报账单' },
      name: "red-purchase-account",
      component: resolve => {
        require(["@/views/billing-center/purchase-account/red-purchase-account/index.vue"], resolve);
      }
    },

    {
      path: "/pay-account-manage",
      title: "付款单",
      icon: "icon-shoufukuanpiaoju",
      meta: { title: '报账中心-付款单' },
      name: "pay-account-manage",
      component: resolve => {
        require(["@/views/billing-center/purchase-account/pay-account-manage/index.vue"], resolve);
      }
    },
    {
      path: "/red-pay-account",
      title: "红字付款单",
      icon: "icon-hongzidan",
      meta: { title: '报账中心-红字付款单' },
      name: "red-pay-account",
      component: resolve => {
        require(["@/views/billing-center/purchase-account/red-pay-account/index.vue"], resolve);
      }
    },
    {
      path: "/supplier-handle-search",
      title: "应付管理",
      icon: "icon-gongyingshang",
      meta: { title: '报账中心-应付管理' },
      name: "supplier-handle-search",
      component: resolve => {
        require(["@/views/billing-center/purchase-account/supplier-handle-search/index.vue"], resolve);
      }
    }]
  },
  //销售报账
  {
    path: '/sale-reimbursement',
    icon: 'sale-reimbursement',
    title: '销售报账',
    name: 'sale-reimbursement',
    component: Main,
    children: [{
      path: "/sale-reimbursement-manage",
      title: "销售报账单",
      icon: "icon-xiaoshoubaozhangguanli",
      meta: { title: '报账中心-销售报账单' },
      name: "sale-reimbursement-manage",
      component: resolve => {
        require(["@/views/billing-center/sale-reimbursement/sale-reimbursement-manage/index.vue"], resolve);
      }
    },
    {
      path: "/sale-receipt-manage",
      title: "收款单",
      icon: "icon-shoufukuanpiaoju",
      meta: { title: '报账中心-收款单' },
      name: "sale-receipt-manage",
      component: resolve => {
        require(["@/views/billing-center/sale-reimbursement/sale-receipt-manage/index.vue"], resolve);
      }
    },
    {
      path: "/sale-customer-query",
      title: "应收管理",
      icon: "icon-kehuyingshou",
      meta: { title: '报账中心-应收管理' },
      name: "sale-customer-query",
      component: resolve => {
        require(["@/views/billing-center/sale-reimbursement/sale-customer-query/index.vue"], resolve);
      }
    },
    {
      path: "/red-sales-reimbursement",
      title: "红字销售报账单",
      icon: "icon-kehuyingshou",
      meta: { title: '报账中心-红字销售报账单' },
      name: "red-sales-reimbursement",
      component: resolve => {
        require(["@/views/billing-center/sale-reimbursement/red-sales-reimbursement/index.vue"], resolve);
      }
    },
    {
      path: "/red-sale-receipt-manage",
      title: "红字收款单",
      icon: "icon-kehuyingshou",
      meta: { title: '报账中心-红字收款单' },
      name: "red-sale-receipt-manage",
      component: resolve => {
        require(["@/views/billing-center/sale-reimbursement/red-sale-receipt-manage/index.vue"], resolve);
      }
    }
    ]
  },
  //库存报账
  {
    path: '/inventory-reimbursement',
    icon: 'inventory-reimbursement',
    title: '库存报账',
    name: 'inventory-reimbursement',
    component: Main,
    children: [{
      path: "/warehouse-reimbursement",
      title: "入库报账单",
      icon: "icon-yingshoudan",
      meta: { title: '报账中心-入库报账单' },
      name: "warehouse-reimbursement",
      component: resolve => {
        require(['../views/billing-center/inventory-reimbursement/warehouse-reimbursement/index'], resolve);
      }
    },
    {
      path: "/outbound-reimbursement",
      title: "出库报账单",
      icon: "icon-qitachukudan1",
      meta: { title: '报账中心-出库报账单' },
      name: "outbound-reimbursement",
      component: resolve => {
        require(["../views/billing-center/inventory-reimbursement/outbound-reimbursement/index"], resolve);
      }
    }

    ]
  },
  //资产报账
  {
    path: '/asset-reimbursement',
    icon: 'asset-reimbursement',
    title: '资产报账',
    name: 'asset-reimbursement',
    component: Main,
    children: [{
      path: "/add-assets",
      title: "新增资产报账单",
      icon: "icon-tianjia",
      meta: { title: '报账中心-新增资产报账单' },
      name: "add-assets",
      component: resolve => {
        require(['../views/billing-center/asset-reimbursement/add-assets/index'], resolve);
      }
    },
    {
      path: "/add-original",
      title: "原值增加报账单",
      icon: "icon-yuanzhizengjia",
      meta: { title: '报账中心-原值增加报账单' },
      name: "add-original",
      component: resolve => {
        require(['../views/billing-center/asset-reimbursement/add-assets/index'], resolve);
      }
    },
    {
      path: "/depreciation-amortize",
      title: "折旧摊销报账单",
      icon: "icon-zhejiu",
      meta: { title: '报账中心-折旧摊销报账单' },
      name: "depreciation-amortize",
      component: resolve => {
        require(['../views/billing-center/asset-reimbursement/add-assets/index'], resolve);
      }
    },

    {
      path: "/clear-assets",
      title: "资产清理报账单",
      icon: "icon-qingli",
      meta: { title: '报账中心-资产清理报账单' },
      name: "clear-assets",
      component: resolve => {
        require(['../views/billing-center/asset-reimbursement/add-assets/index'], resolve);
      }
    },

    ]
  },

  //薪资报账
  {
    path: '/salaries-accounted',
    icon: 'salaries-accounted',
    title: '薪资报账',
    name: 'salaries-accounted',
    component: Main,
    children: [{
      path: "/job-salary",
      title: "薪资报账单",
      icon: "icon-jiesuandan",
      meta: { title: '报账中心-薪资报账单' },
      name: "job-salary",
      component: resolve => {
        require(["@/views/billing-center/salaries-accounted/job-salary/index.vue"], resolve);
      }
    },
    {
      path: "/labor-remuneration",
      title: "劳务报账单",
      icon: "icon-fapiaoshenqingdan-1",
      meta: { title: '报账中心-劳务报账单' },
      name: "labor-remuneration",
      component: resolve => {
        require(["@/views/billing-center/salaries-accounted/labor-remuneration/index.vue"], resolve);
      }
    },

    {
      path: "/wages",
      title: "薪资发放单",
      icon: "icon-qimojiezhang",
      meta: { title: '报账中心-薪资发放单' },
      name: "wages",
      component: resolve => {
        require(["@/views/billing-center/salaries-accounted/wages/index.vue"], resolve);
      }
    },
    ]
  },

  //结算中心
  {
    path: '/settlement-center',
    icon: 'settlement-center',
    title: '结算任务',
    name: 'settlement-center',
    component: Main,
    children: [
      {
        path: "/settlement-task",
        title: "结算任务",
        icon: "icon-baozhangrenwu",
        meta: { title: '结算中心-结算任务' },
        name: "settlement-task",
        component: resolve => {
          require(["@/views/settlement-center/settlement-task/index.vue"], resolve);
        }
      },
    ]
  },
  {
    path: '/settlement-document',
    icon: 'settlement-document',
    title: '费用结算',
    name: 'settlement-document',
    component: Main,
    children: [{
      path: "/settlement-document-page",
      title: "费用结算单",
      meta: { title: '结算中心-费用结算单' },
      icon: "icon-fuzhuhesuan",
      name: "settlement-document-page",
      component: resolve => {
        require(["@/views/settlement-center/settlement-document/index.vue"], resolve);
      }
    },
    {
      path: "/settlement-loan",
      title: "借款单",
      icon: "icon-qitachukudan",
      meta: { title: '结算中心-借款单' },
      name: "settlement-loan",
      component: resolve => {
        require(["@/views/settlement-center/settlement-loan/index.vue"], resolve);
      }
    },
    {
      path: "/settlement-repay-ment",
      title: "还款单",
      icon: "icon-qitachukudan",
      meta: { title: '结算中心-还款单' },
      name: "settlement-repay-ment",
      component: resolve => {
        require(["@/views/settlement-center/repay-ment/index.vue"], resolve);
      }
    }]
  },
  {
    path: '/pay-for-purchase',
    title: '采购付款',
    name: 'pay-for-purchase',
    component: Main,
    children: [
      {
        path: "/payment-order",
        title: "付款单",
        icon: "icon-yingshoudan",
        meta: { title: '结算中心-付款单' },
        name: "payment-order",
        component: resolve => {
          require(["@/views/settlement-center/payment-order/index.vue"], resolve);
        }
      },
      {
        path: "/red-payment-settlement",
        title: "红字付款单",
        icon: "icon-yingshoudan",
        meta: { title: '结算中心-红字付款单' },
        name: "red-payment-settlement",
        component: resolve => {
          require(["@/views/settlement-center/red-payment-order/index.vue"], resolve);
        }
      }
    ]
  },
  {
    path: '/collection-of-sale',
    title: '销售收款',
    name: 'collection-of-sale',
    component: Main,
    children: [{
      path: "/sale-collection",
      title: "收款单",
      icon: "icon-jiesuandan",
      meta: { title: '结算中心-收款单' },
      name: "sale-collection",
      component: resolve => {
        require(["@/views/settlement-center/sale-collection/index.vue"], resolve);
      }
    },
    {
      path: "/red-sale-collection",
      title: "红字收款单",
      icon: "icon-jiesuandan",
      meta: { title: '结算中心-红字收款单' },
      name: "red-sale-collection",
      component: resolve => {
        require(["@/views/settlement-center/red-sale-collection/index.vue"], resolve);
      }
    },
    ]
  },
  //结算中心 其它付款
  {
    path: '/other-payment',
    title: '其它付款',
    name: 'other-payment',
    component: Main,
    children: [
      {
        path: "/wages-settlement",
        title: "薪资发放单",
        icon: "icon-qimojiezhang",
        meta: { title: ' 结算中心-薪资发放单' },
        name: "wages-settlement",
        component: resolve => {
          require(["@/views/settlement-center/other-payment/wages/index.vue"], resolve);
        }
      },
    ]
  },

  /** 会计核算 **/
  // 会计核算设置
  {
    path: '/finance-account-setting',
    icon: 'finance-account-setting',
    title: '设置',
    name: 'finance-account-setting',
    component: Main,
    children: [{
      path: "/personalize-setting",
      title: "个性化设置",
      icon: "icon-shezhi",
      meta: { title: '会计核算-个性化设置' },
      name: "personalize-setting",
      component: resolve => {
        require(["@/views/finance-account/finance-account-setting/personalize-setting/index.vue"], resolve);
      }
    },
    {
      path: "/beginning-balance",
      title: "期初余额",
      icon: "icon-qichuyue",
      meta: { title: '会计核算-期初余额' },
      name: "beginning-balance",
      component: resolve => {
        require(["@/views/finance-account/finance-account-setting/beginning-balance/index.vue"], resolve);
      }
    },
    {
      path: "account-report-set",
      title: "报表设置",
      icon: "icon-baobiaoshezhi",
      meta: {
        title: '会计核算-报表设置'
      },
      name: "account-report-set",
      component: resolve => {
        require(["../views/finance-account/finance-account-setting/report-set/index"], resolve);
      }
    },
    ]
  },
  // 会计凭证
  {
    path: '/account-voucher',
    icon: 'account-voucher',
    title: '会计凭证',
    name: 'account-voucher',
    component: Main,
    children: [{
      path: "/voucher-manage",
      title: "凭证管理",
      meta: { title: '会计核算-凭证管理' },
      name: "voucher-manage",
      icon: "icon-pingzhenghuizongbiao",
      component: resolve => {
        require(["@/views/finance-account/account-voucher/voucher-manage/index.vue"], resolve);
      }
    },
    {
      path: "/voucher-audit",
      title: "审核凭证",
      meta: { title: '会计核算-审核凭证' },
      icon: "icon-shenhepingzheng",
      name: "voucher-audit",
      component: resolve => {
        require(["@/views/finance-account/account-voucher/voucher-manage/index.vue"], resolve);
      }
    },
    {
      path: "/voucher-cashier",
      title: "出纳签字",
      icon: "icon-chunaqianzi",
      meta: { title: '会计核算-出纳签字' },
      name: "voucher-cashier",
      component: resolve => {
        require(["@/views/finance-account/account-voucher/voucher-manage/index.vue"], resolve);
      }
    },
    {
      path: "/add-voucher",
      title: "新增凭证",
      icon: "icon-xinzeng",
      meta: { title: '会计核算-新增凭证' },
      name: "add-voucher",
      component: resolve => {
        require(["@/views/finance-account/account-voucher/add-voucher/index.vue"], resolve);
      }
    },
    {
      path: "/voucher-summary",
      title: "科目汇总表",
      icon: "icon-huizongbiao",
      meta: { title: '会计核算-科目汇总表' },
      name: "voucher-summary",
      component: resolve => {
        require(["@/views/finance-account/account-voucher/voucher-summary/index.vue"], resolve);
      }
    },
    ]
  },
  // 期末
  {
    path: '/end-period',
    icon: 'end-period',
    title: '期末',
    name: 'end-period',
    component: Main,
    children: [{
      path: "/end-period-closing",
      title: "期末结账",
      meta: { title: '会计核算-期末结账' },
      name: "end-period-closing",
      icon: "icon-qimojiezhang",
      component: resolve => {
        require(["@/views/finance-account/end-period/end-period-closing/index.vue"], resolve);
      }
    },
    {
      path: "/end-period-carry-over",
      title: "期末结转",
      meta: { title: '会计核算-期末结转' },
      name: "end-period-carry-over",
      icon: "icon-qimojiezhuan",
      component: resolve => {
        require(["@/views/finance-account/end-period/end-period-carry-over/index.vue"], resolve);
      }
    },
    ]
  },
  //账簿
  {
    path: '/account-books',
    icon: 'account-books',
    title: '账簿',
    name: 'account-books',
    component: Main,
    children: [{
      path: "/account-general-ledger",
      title: "科目总账",
      meta: { title: '会计核算-科目总账' },
      icon: "icon-a-caidanzongzhang",
      name: "account-general-ledger",
      component: resolve => {
        require(["@/views/finance-account/account-books/account-general-ledger/index.vue"], resolve);
      }
    },
    {
      path: "/account-sub-ledger",
      title: "科目明细账",
      icon: "icon-mingxizhang",
      meta: { title: '会计核算-科目明细账' },
      name: "account-sub-ledger",
      component: resolve => {
        require(["@/views/finance-account/account-books/account-sub-ledger/index.vue"], resolve);
      }
    },
    {
      path: "/chronological-account",
      title: "序时账",
      icon: "icon-xushizhang",
      meta: { title: '会计核算-序时账' },
      name: "chronological-account",
      component: resolve => {
        require(["@/views/finance-account/account-books/chronological-account/index.vue"], resolve);
      }
    },
    {
      path: "/account-balance-table",
      icon: "icon-yuebiao",
      title: "科目余额表",
      meta: { title: '会计核算-科目余额表' },
      name: "account-balance-table",
      component: resolve => {
        require(["@/views/finance-account/account-books/account-balance-table/index.vue"], resolve);
      }
    },
    {
      path: "/currency-balance-table",
      title: "外币余额表",
      meta: { title: '会计核算-外币余额表' },
      icon: "icon-waibi",
      name: "currency-balance-table",
      component: resolve => {
        require(["@/views/finance-account/account-books/currency-balance-table/index.vue"], resolve);
      }
    },
    {
      path: "/assist-account-detail",
      title: "辅助核算明细账",
      icon: "icon-mingxizhang",
      meta: { title: '会计核算-辅助核算明细账' },
      name: "assist-account-detail",
      component: resolve => {
        require(["@/views/finance-account/account-books/assist-account-detail/index.vue"], resolve);
      }
    },
    {
      path: "/assist-account-balance",
      title: "辅助核算余额表",
      icon: "icon-yuebiao",
      meta: { title: '会计核算-辅助核算余额表' },
      name: "assist-account-balance",
      component: resolve => {
        require(["@/views/finance-account/account-books/assist-account-balance/index.vue"], resolve);
      }
    },
    ]
  },
  //报表
  {
    path: '/statement-management',
    icon: 'statement-management',
    title: '报表',
    name: 'statement-management',
    component: Main,
    children: [{
      path: "/month-statement",
      title: "月报",
      meta: { title: '会计核算-月报' },
      icon: "icon-yuebao",
      name: "month-statement",
      component: resolve => {
        require(["../views/finance-account/statement-management/statement/index"], resolve);
      }
    },
    {
      path: "/quaret-statement",
      title: "季报",
      icon: "icon-jibao",
      meta: { title: '会计核算-季报' },
      name: "quaret-statement",
      component: resolve => {
        require(["../views/finance-account/statement-management/statement/index"], resolve);
      }
    },
    {
      path: "/year-statement",
      title: "年报",
      icon: "icon-nianbao",
      meta: { title: '会计核算-年报' },
      name: "year-statement",
      component: resolve => {
        require(["../views/finance-account/statement-management/statement/index"], resolve);
      }
    },
    ]
  },
  //云开票
  {
    path: '/cloud-invoicing',
    icon: 'cloud-invoicing',
    title: '云开票',
    name: 'cloud-invoicing',
    component: Main,
    children: [{
      path: "/bill-invoicing",
      title: "发票开具",
      meta: { title: '开票平台-发票开具' },
      icon: "icon-gongju",
      name: "bill-invoicing",
      component: resolve => {
        require(["../views/bill-management/cloud-invoicing/invoicing/index"], resolve);
      }
    },
    {
      path: "/invoice-registration",
      title: "发票登记",
      meta: { title: '开票平台-发票登记' },
      icon: "icon-edit-1",
      name: "invoice-registration",
      component: resolve => {
        require(["../views/bill-management/cloud-invoicing/invoice-registration/index"], resolve);
      }
    },
    ]
  },
  //税控管理
  {
    path: '/tax-control-management',
    icon: 'tax-control-management',
    title: '税控管理',
    name: 'tax-control-management',
    component: Main,
    children: [{
      path: "/tax-server",
      title: "税控服务器管理",
      meta: { title: '开票平台-税控服务器管理' },
      icon: "icon-yunhangzhongxin",
      name: "tax-server",
      component: resolve => {
        require(["../views/bill-management/tax-control-management/tax-server/index"], resolve);
      }
    },
    {
      path: "/billing-outlet",
      title: "开票网点管理",
      meta: { title: '开票平台-开票网点管理' },
      icon: "icon-wang",
      name: "billing-outlet",
      component: resolve => {
        require(["../views/bill-management/tax-control-management/billing-outlet/index"], resolve);
      }
    },
    ]
  },
  //发票基础设置
  {
    path: '/invoice-basic-settings',
    icon: 'invoice-basic-settings',
    title: '基础设置',
    name: 'invoice-basic-settings',
    component: Main,
    children: [{
      path: "/basic-settings",
      title: "纳税主体管理",
      meta: { title: '开票平台-纳税主体管理' },
      icon: "icon-shezhi",
      name: "basic-settings",
      component: resolve => {
        require(["../views/bill-management/invoice-basic-settings/basic-settings/index"], resolve);
      }
    },
    ]
  },
  //资产管理
  {
    path: '/base-management',
    icon: 'base-management',
    title: '资产基础设置',
    name: 'base-management',
    component: Main,
    children: [{
      path: "/personality-settings",
      title: "个性化设置",
      meta: { title: '资产管理-个性化设置' },
      icon: "icon-shezhi",
      name: "personality-settings",
      component: resolve => {
        require(["../views/assest-management/base-management/personality-settings/index"], resolve);
      }
    },
    {
      path: "/asset-types",
      title: "资产分类",
      meta: { title: '资产管理-资产分类' },
      icon: "icon-zhucaidan",
      name: "asset-types",
      component: resolve => {
        require(["../views/assest-management/base-management/asset-types/index"], resolve);
      }
    },
    {
      path: "/asset-place",
      title: "地点位置",
      meta: { title: '资产管理-地点位置' },
      icon: "icon-weizhi",
      name: "asset-place",
      component: resolve => {
        require(["../views/assest-management/base-management/asset-place/index"], resolve);
      }
    },
    ]

  },
  {
    path: '/assets-register',
    icon: 'assets-register',
    title: '资产登记',
    name: 'assets-register',
    component: Main,
    children: [{
      path: "/fixed-assets-register",
      title: "固定资产",
      meta: { title: '资产管理-固定资产' },
      icon: "icon-zichan",
      name: "fixed-assets-register",
      component: resolve => {
        require(["../views/assest-management/assets-register/fixed-assets-register/index"], resolve);
      }
    },
    {
      path: "/intangible-assets-register",
      title: "无形资产",
      meta: { title: '资产管理-无形资产' },
      icon: "icon-huizongbiao",
      name: "intangible-assets-register",
      component: resolve => {
        require(["../views/assest-management/assets-register/fixed-assets-register/index"], resolve);
      }
    },
    {
      path: "/biological-assets-register",
      title: "生物资产",
      meta: { title: '资产管理-生物资产' },
      icon: "icon-gongyi",
      name: "biological-assets-register",
      component: resolve => {
        require(["../views/assest-management/assets-register/fixed-assets-register/index"], resolve);
      }
    },
    ]

  },
  {
    path: '/business-process',
    icon: 'business-process',
    title: '业务处理',
    name: 'business-process',
    component: Main,
    children: [{
      path: "/original-add",
      title: "原值增加",
      meta: { title: '资产管理-原值增加' },
      icon: "icon-tianjia",
      name: "original-add",
      component: resolve => {
        require(["../views/assest-management/business-process/original-add/index"], resolve);
      }
    },
    {
      path: "/assets-remove",
      title: "资产清理",
      meta: { title: '资产管理-资产清理' },
      icon: "icon-qingli",
      name: "assets-remove",
      component: resolve => {
        require(["../views/assest-management/business-process/assets-remove/index"], resolve);
      }
    },
    {
      path: "/assets-transfer",
      title: "资产调拨",
      meta: { title: '资产管理-资产调拨' },
      icon: "icon-tiaobo",
      name: "assets-transfer",
      component: resolve => {
        require(["../views/assest-management/business-process/assets-transfer/index"], resolve);
      }
    },
    {
      path: "/usage-adjustment",
      title: "使用状况调整",
      meta: { title: '资产管理-使用状况调整' },
      icon: "icon-tiaozheng",
      name: "usage-adjustment",
      component: resolve => {
        require(["../views/assest-management/business-process/usage-adjustment/index"], resolve);
      }
    },
    {
      path: "/accrual-close-account",
      title: "折旧和关账",
      meta: { title: '资产管理-折旧和关账' },
      icon: "icon-zhejiu",
      name: "accrual-close-account",
      component: resolve => {
        require(["../views/assest-management/business-process/accrual-close-account/index"], resolve);
      }
    },
    ]

  },
  {
    path: '/reimbursement-platform',
    icon: 'reimbursement-platform',
    title: '报账平台',
    name: 'reimbursement-platform',
    component: Main,
    children: [{
      path: "/assets-reimbursement",
      title: "资产报账",
      meta: { title: '资产管理-资产报账' },
      icon: "icon-jiesuandan",
      name: "assets-reimbursement",
      component: resolve => {
        require(["../views/assest-management/assets-reimbursement/index"], resolve);
      }
    },
    ]
  },
  /** 薪资管理 **/
  // 薪资管理-设置
  {
    path: '/salary-manage-setting',
    icon: 'salary-manage-setting',
    title: '薪资管理设置',
    name: 'salary-manage-setting',
    component: Main,
    children: [{
      path: "/individual-tax-withhold-rate",
      title: "个税预扣率表",
      meta: { title: '薪资管理-个税预扣率表' },
      icon: "icon-shuibiao",
      name: "individual-tax-withhold-rate",
      component: resolve => {
        require(["../views/salary-manage/setting/individual-tax-withhold-rate/index"], resolve);
      }
    },
    {
      path: "/staff-info",
      title: "人员信息",
      meta: { title: '薪资管理-人员信息' },
      icon: "icon-renyuanxinxi",
      name: "staff-info",
      component: resolve => {
        require(["../views/salary-manage/setting/staff-info/index"], resolve);
      }
    },
    {
      path: "/personality-settings-salary",
      title: "个性化设置",
      meta: { title: '薪资管理-个性化设置' },
      icon: "icon-shezhi",
      name: "personality-settings-salary",
      component: resolve => {
        require(["../views/salary-manage/setting/personality-settings/index"], resolve);
      }
    },
    {
      path: "/salary-item-setting",
      title: "工资项目设置",
      meta: { title: '薪资管理-工资项目设置' },
      icon: "icon-shezhi",
      name: "salary-item-setting",
      component: resolve => {
        require(["../views/salary-manage/setting/salary-item-setting/index"], resolve);
      }
    },
    ]
  },
  {
    path: '/current-info',
    icon: 'current-info',
    title: '本期信息',
    name: 'current-info',
    component: Main,
    children: [{
      path: "/basic-info-collect",
      title: "基本信息采集",
      meta: { title: '薪资管理-基本信息采集' },
      icon: "icon-huizongbiao",
      name: "basic-info-collect",
      component: resolve => {
        require(["../views/salary-manage/current-info/basic-info-collect/index"], resolve);
      }
    },
    {
      path: "/staff-specific-info-collect",
      title: "专项信息采集",
      meta: { title: '薪资管理-专项信息采集' },
      icon: "icon-tiaozhengdan",
      name: "staff-specific-info-collect",
      component: resolve => {
        require(["../views/salary-manage/current-info/staff-specific-info-collect/index"], resolve);
      }
    },
    {
      path: "/salary-init",
      title: "薪资初始化",
      meta: { title: '薪资管理-薪资初始化' },
      icon: "icon-jiesuandan",
      name: "salary-init",
      component: resolve => {
        require(["../views/salary-manage/current-info/salary-init/index"], resolve);
      }
    },
    ]
  },

  {
    path: '/salary-calculation',
    icon: 'salary-calculation',
    title: '薪酬计算',
    name: 'salary-calculation',
    component: Main,
    children: [{
      path: "/salary-data-prepare",
      title: "工资数据准备",
      meta: { title: '薪资管理-工资数据准备' },
      icon: "icon-jiesuandan",
      name: "salary-data-prepare",
      component: resolve => {
        require(["../views/salary-manage/salary-calculation/salary-data-prepare/index"], resolve);
      }
    },
    {
      path: "/wage-calculation",
      title: "工资薪金计算",
      meta: { title: '薪资管理-工资薪金计算' },
      icon: "icon-jiesuandan",
      name: "wage-calculation",
      component: resolve => {
        require(["../views/salary-manage/salary-calculation/wage-calculation/index"], resolve);
      }
    },
    {
      path: "/labour-calculation",
      title: "劳务报酬计算",
      meta: { title: '薪资管理-劳务报酬计算' },
      icon: "icon-fapiaoshenqingdan-1",
      name: "labour-calculation",
      component: resolve => {
        require(["../views/salary-manage/salary-calculation/labour-calculation/index"], resolve);
      }
    },
    {
      path: "/individual-tax-return",
      title: "个税申报表",
      meta: { title: '薪资管理-个税申报表' },
      icon: "icon-shuibiao",
      name: "individual-tax-return",
      component: resolve => {
        require(["../views/salary-manage/salary-calculation/individual-tax-return/index"], resolve);
      }
    },
    ]
  },
  {
    path: '/reimbursement-platform',
    icon: 'reimbursement-platform',
    title: '薪资报账平台',
    name: 'reimbursement-platform',
    component: Main,
    children: [{
      path: "/salary-reimbursement",
      title: "工资薪金报账",
      meta: { title: '薪资管理-工资薪金报账' },
      icon: "icon-jiesuandan",
      name: "salary-reimbursement",
      component: resolve => {
        require(["../views/salary-manage/salary-reimbursement/index"], resolve);
      }
    },
    {
      path: "/labour-reimbursement",
      title: "劳务报酬报账",
      meta: { title: '薪资管理-劳务报酬报账' },
      icon: "icon-fapiaoshenqingdan-1",
      name: "labour-reimbursement",
      component: resolve => {
        require(["../views/salary-manage/salary-reimbursement/index"], resolve);
      }
    },
    {
      path: "/remuneration-reimbursement",
      title: "薪酬发放报账",
      meta: { title: '薪资管理-薪酬发放报账' },
      icon: "icon-qimojiezhang",
      name: "remuneration-reimbursement",
      component: resolve => {
        require(["../views/salary-manage/salary-reimbursement/index"], resolve);
      }
    },
    {
      path: "/withdrawFunds-reimbursement",
      title: "计提经费报账",
      meta: { title: '薪资管理-计提经费报账' },
      icon: "icon-qimojiezhang",
      name: "withdrawFunds-reimbursement",
      component: resolve => {
        require(["../views/salary-manage/salary-reimbursement/index"], resolve);
      }
    },
    ]
  },
  {
    path: '/collection-documents',
    icon: 'collection-documents',
    title: '档案收集',
    name: 'collection-documents',
    component: Main,
    children: [{
      path: "accounting-voucher",
      title: "档案管理",
      meta: { title: '档案收集-档案管理' },
      icon: "icon-jiesuandan",
      name: "accounting-voucher",
      component: resolve => {
        require(["../views/record-management/collection-documents/accounting-voucher/index"], resolve);
      }
    },
    {
      path: "accounting-statements",
      title: "会计报表",
      meta: { title: '档案收集-会计报表' },
      icon: "icon-jiesuandan",
      name: "accounting-statements",
      component: resolve => {
        require(["../views/record-management/collection-documents/accounting-statements/index"], resolve);
      }
    },
    {
      path: "accounting-books",
      title: "会计账簿",
      meta: { title: '档案收集-会计账簿' },
      icon: "icon-jiesuandan",
      name: "accounting-books",
      component: resolve => {
        require(["../views/record-management/collection-documents/accounting-books/index"], resolve);
      }
    },
    {
      path: "accounting-voucher-file",
      title: "会计凭证资料",
      meta: { title: '档案收集-会计凭证资料' },
      icon: "icon-jiesuandan",
      name: "accounting-voucher-file",
      component: resolve => {
        require(["../views/record-management/collection-documents/accounting-voucher-file/index"], resolve);
      }
    },
    {
      path: "accounting-statements-file",
      title: "会计报表资料",
      meta: { title: '档案收集-会计报表资料' },
      icon: "icon-jiesuandan",
      name: "accounting-statements-file",
      component: resolve => {
        require(["../views/record-management/collection-documents/accounting-statements-file/index"], resolve);
      }
    },
    {
      path: "accounting-books-file",
      title: "会计账簿资料",
      meta: { title: '档案收集-会计账簿资料' },
      icon: "icon-jiesuandan",
      name: "accounting-books-file",
      component: resolve => {
        require(["../views/record-management/collection-documents/accounting-books-file/index"], resolve);
      }
    },
    {
      path: "other-file",
      title: "其他档案资料",
      meta: { title: '档案收集-其他档案资料' },
      icon: "icon-jiesuandan",
      name: "other-file",
      component: resolve => {
        require(["../views/record-management/collection-documents/other-file/index"], resolve);
      }
    },
    ]
  },
  {
    path: '/system-maagement',
    icon: 'system-maagement',
    title: '系统管理',
    name: 'system-maagement',
    component: Main,
    children: [{
      path: "/record-group-number",
      title: "全宗号",
      meta: { title: '系统管理-全宗号' },
      icon: "icon-jiesuandan",
      name: "record-group-number",
      component: resolve => {
        require(["../views/record-management/system-maagement/record-group-number/index"], resolve);
      }
    },


    ]
  },
  {
    path: '/task-maagement',
    icon: 'task-maagement',
    title: '任务管理',
    name: 'task-maagement',
    component: Main,
    children: [{
      path: "/task-maagement",
      title: "任务管理",
      meta: { title: '任务管理' },
      icon: "icon-jiesuandan",
      name: "task-maagement",
      component: resolve => {
        require(["../views/record-management/task-management/index"], resolve);
      }
    },


    ]

  },
  {
    path: '/record-maagement',
    icon: 'record-maagement',
    title: '档案整理',
    name: 'record-maagement',
    component: Main,
    children: [{
      path: "/record-pigeonhole",
      title: "档案归档",
      meta: { title: '档案整理-档案归档' },
      icon: "icon-jiesuandan",
      name: "record-pigeonhole",
      component: resolve => {
        require(["../views/record-management/record-pigeonhole/index.vue"], resolve);
      }
    },


    ]

  },
  {
    path: '/record-use',
    icon: 'record-use',
    title: '档案利用',
    name: 'record-use',
    component: Main,
    children: [
      {
        path: "/my-borrow",
        title: "我的借阅",
        meta: { title: '档案整理-我的借阅' },
        icon: "icon-jiesuandan",
        name: "my-borrow",
        component: resolve => {
          require(["../views/record-management/record-use/borrow-management/index.vue"], resolve);
        }
      },
      {
        path: "/borrow-approve",
        title: "借阅审批",
        meta: { title: '档案整理-借阅审批' },
        icon: "icon-jiesuandan",
        name: "borrow-approve",
        component: resolve => {
          require(["../views/record-management/record-use/borrow-management/index.vue"], resolve);
        }
      },
      {
        path: "/record-search",
        title: "档案检索",
        meta: { title: '档案整理-档案检索' },
        icon: "icon-jiesuandan",
        name: "record-search",
        component: resolve => {
          require(["../views/record-management/record-use/record-search/index.vue"], resolve);
        }
      },


    ]

  },
  //成本核算
  {
    path: '/initial-settings',
    icon: 'initial-settings',
    title: '成本初始化设置',
    name: 'initial-settings',
    component: Main,
    children: [{
      path: "/personalization-settings",
      title: "个性化设置",
      icon: "",
      meta: { title: '成本核算-个性化设置' },
      name: "personalization-settings",
      component: resolve => {
        require(["../views/cost-accounting/initial-settings/personalization-settings/index"], resolve);
      }
    },
    {
      path: "/department-management",
      title: "部门管理",
      icon: "",
      meta: { title: '成本核算-部门管理' },
      name: "department-management",
      component: resolve => {
        require(["../views/cost-accounting/initial-settings/department-management/index"], resolve);
      }
    },
    {
      path: "/inventory-quota",
      title: "存货定额",
      icon: "",
      meta: { title: '成本核算-存货定额' },
      name: "inventory-quota",
      component: resolve => {
        require(["../views/cost-accounting/initial-settings/inventory-quota/index"], resolve);
      }
    },
    {
      path: "/cost-center",
      title: "成本中心",
      icon: "",
      meta: { title: '成本核算-成本中心' },
      name: "cost-center",
      component: resolve => {
        require(["../views/cost-accounting/initial-settings/cost-center/index"], resolve);
      }
    },
    {
      path: "/goods-process",
      title: "在产品",
      icon: "",
      meta: { title: '成本核算-在产品' },
      name: "goods-process",
      component: resolve => {
        require(["../views/cost-accounting/initial-settings/goods-process/index"], resolve);
      }
    },
    ]
  },
  {
    path: '/inventory-accounting',
    icon: 'inventory-accounting',
    title: '存货核算',
    name: 'inventory-accounting',
    component: Main,
    children: [
      {
        path: "/stock-book-monthly",
        title: "存货明细账(全月平均)",
        icon: "",
        meta: { title: '成本核算-存货明细账(全月平均)' },
        name: "stock-book-monthly",
        component: resolve => {
          require(["../views/cost-accounting/inventory-accounting/stock-book-monthly/index"], resolve);
        }
      },
      {
        path: "/sending-receiving-storing",
        title: "收发存汇总表",
        icon: "",
        meta: { title: '成本核算-收发存汇总表' },
        name: "sending-receiving-storing",
        component: resolve => {
          require(["../views/cost-accounting/inventory-accounting/sending-receiving-storing/index"], resolve);
        }
      },]
  }
];

/**
 * 需要权限检查的router.
 * 即，可以定义access的路由
 */
export const authRouters = initAuthRouters([
  ...menuRouters,
  otherRouter,
  accountRouter,
  loginRouter,
  loginSSORouter,
]);
/**
 * 需要显示标签页的路由,
 * 该类路由都由Main.vue作为一级路由页面，
 * 所以所有的路由都有如下配置:
 * component: Main,
 * children:[]
 */
export const tagRouters = [
  ...menuRouters,
  otherRouter
];

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
  loginRouter,
  loginSSORouter,
  accountRouter,
  otherRouter,
  ...menuRouters,
  page403,
  page404,
];



// WEBPACK FOOTER //
// ./src/router/router.js